var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-provider',{attrs:{"rules":_vm.fieldRules,"name":_vm.config.field},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_vm._t("default",null,{"errors":errors})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }